<template>
  <v-container class="top-spacer" style="padding:0">
    <div class="component-title">Dashboard</div>
    <v-row style="overflow: auto;">
      <v-col cols="12">
        <v-row>
          <v-col class="dashboard-col">
            <div class="card-label">Bigometro</div>
            <BigometroCard :isComponent="true"></BigometroCard>
          </v-col>
          <v-col class="dashboard-col">
            <div class="card-label">Tiro Certeiro</div>
            <TiroCerteiroCard
              :tiroCerteiro="current"
              :ranking="ranking.slice(0,5)"
              :isComponent="true"
            ></TiroCerteiroCard>
          </v-col>
        </v-row>
        <!-- Prognósticos -->
        <PrognosticList
          :label="'Prognósticos'"
          :isComponent="true"
        ></PrognosticList>
      </v-col>
    </v-row>
  </v-container>
</template>

<style scoped>
.dashboard-col {
  flex: 0 0 50%;
  max-width: 580px;
}
@media only screen and (max-width: 1112px) {
  .dashboard-col {
    flex: 0 0 100%;
    max-width: 100%;
  }
}
@media only screen and (max-width: 768px) {
}
</style>

<script>
import store from "../store"
import PrognosticList from "@/components/PrognosticList.vue";
import BigometroCard from "@/components/BigometroCard.vue";
import TiroCerteiroCard from "@/components/TiroCerteiroCard.vue";

import ApiService from "../services/api.service";

export default {
  name: "Dashboard",
  components: {
    PrognosticList,
    BigometroCard,
    TiroCerteiroCard
  },
  data: () => ({
    prognostics: {},
    current: {},
    ranking: []
  }),
  methods: {
    getTiroCerteiroInfo() {
      ApiService.getGraphQLCurrentTiroCerteiroRanking().then(
        response => {
          const data = response.data.data;
          this.current = data.getCurrentTiroCerteiro;
          this.ranking = data.getCurrentTiroCerteiroRanking;
          this.checkIfContainsUser(this.ranking);
          const empty = 5 - this.ranking.length;
          for (let i = 0; i < empty; i++) {
            this.ranking.push({});
          }
        },
        error => {
          console.log(
            (error.response && error.response.data) ||
              error.message ||
              error.toString()
          );
        }
      );
    }, 
    checkIfContainsUser(array) {
      let index = 0;
      const uid = this.$store.state.user.uid;
      array.forEach(ranking => {
        if (ranking.user.uid == uid) {
          store.commit("setRanking", index.toString());
        }
        index ++;
      });
    }
  },
  mounted() {
    this.getTiroCerteiroInfo();
  }
};
</script>
